import {Component, OnInit} from '@angular/core';
import {EnumerationService} from '../../../services/enumeration.service';
import {ExcRestService} from 'exc-rest-v2';
import {IExgTab} from 'exc-tab-v2';
import {ExcTranslation} from 'exc-core-v2';
import {ExgTabV2ComponentHeaderElement} from '../../../misc/exg-tab-v2/exg-tab-v2.component';

@Component({
  selector: 'app-oe-details',
  templateUrl: './oe-details.component.html',
  styles: []
})
export class OeDetailsComponent extends ExcTranslation implements IExgTab, OnInit {

  Data: any;
  tabinstance: any;

  SummaryData: any;

  contacts: any = {};
  addresses: any = {};
  tabs: ExgTabV2ComponentHeaderElement[] = [];

  constructor(public enumSvc: EnumerationService, private excRest: ExcRestService) {
    super();
    const SELF = this;
    this.tabs = [
      {
        get caption(): string {
          return SELF.getGlobal('Contacts');
        },
        get icon_class(): string {
          return SELF.getTranslation('Icons.Contact');
        }
      },
      {
        get caption(): string {
          return SELF.getGlobal('Addresses');
        },
        get icon_class(): string {
          return SELF.getTranslation('Icons.Address');
        }
      },
      {
        get caption(): string {
          return SELF.getTranslation('Personen');
        },
        get icon_class(): string {
          return SELF.getTranslation('Icons.Persons');
        }
      },
      {
        get caption(): string {
          return SELF.getTranslation('Mitglied von');
        },
        get icon_class(): string {
          return SELF.getTranslation('Icons.Members');
        }
      },
      {
        get caption(): string {
          return SELF.getTranslation('Mitglieder');
        },
        get icon_class(): string {
          return SELF.getTranslation('Icons.Members');
        }
      },
      {
        get caption(): string {
          return SELF.getTranslation('Gruppen');
        },
        get icon_class(): string {
          return SELF.getTranslation('Icons.Groups');
        }
      }
    ];
  }

  ngOnInit(): void {
    this.initialize();
  }

  initialize(): void {
    this.excRest.sget(this.excRest.computeUrl('OESummary', {oeID: this.Data}), 'OESummary' + this.Data).subscribe((response) => {
      if (response && response.success) {
        this.SummaryData = response.data;
        for (const cont of this.SummaryData.Contacts) {
          if (!this.contacts[cont.kont_enmIdent_KontaktTyp as number]) {
            this.contacts[cont.kont_enmIdent_KontaktTyp] = [];
          }
          this.contacts[cont.kont_enmIdent_KontaktTyp].push(cont);
        }
        for (const adr of this.SummaryData.Addresses) {
          if (!this.addresses[adr.adr_enmIdent_AdresseTyp]) {
            this.addresses[adr.adr_enmIdent_AdresseTyp] = [];
          }
          this.addresses[adr.adr_enmIdent_AdresseTyp].push(adr);
        }
      } else {
        this.SummaryData = undefined;
      }
    });

  }

  getNumber(input: any): number {
    return input as number;
  }

  getArray(input: any): any[] {
    return input as any[];
  }


}
